<template>
  <div class="flex-row-nowrap-start-start-baseline">
    <n-spin v-if="loading" :size="16" style="margin-right: 8px" />
    <div style="font-size: 13px; color: #777"><slot></slot></div>
  </div>
</template>
<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    loading?: boolean
  }>(),
  {
    loading: false,
  }
)
</script>
<style scoped></style>
